import { getFullStateName } from "../../../shared/helpers";
import bannerImage from "../../../assets/img/banners/city-view.jpg";
import bannerImageRemote from "../../../assets/img/banners/Full_resolution.png";
export const getImageByStateCode = (stateCode, cityName,CompanyName) => {
  const shiStates = ['NJ', 'TX', 'NC','IL','NY','PA','TX','NC']; 
  const isSHICompany = CompanyName == "SHI" || CompanyName =='SHI International';
  const isSHIState = shiStates.includes(stateCode);
  if (stateCode==null){
    return bannerImageRemote;
  }
  else if (cityName === "state") {
    const url = `https://res.cloudinary.com/skillgigs/image/upload/f_auto,w_800,h_600,c_limit/pwa/${isSHICompany&&isSHIState ? "shi/" : ""}Locations/`;
    const fileName = getFullStateName(stateCode);
    return url + fileName?.replace(" ", "_") + ".jpg";
  } else {
    const url = `https://res.cloudinary.com/skillgigs/image/upload/f_auto,w_800,h_600,c_limit/pwa/${isSHICompany&&isSHIState ? "shi/" : ""}images/${stateCode?.toLowerCase()}/${cityName?.replace(/ /g, "").toLowerCase()}/${stateCode?.toLowerCase()}_${cityName?.replace(/ /g, "").toLowerCase()}.jpg`; 
    return url;
  }
};
  